import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { semanticColors, greyScaleColors } from '../../Globals/styles';
import Calculator from './calculator';
import "../../../Content/Less/salaryWeekDay.css";
import { absenceCodes } from '../../Globals/constants';


class WeekDay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasBeenEdited: this.props.touchedByFunktionaer
    }
  }
  shouldComponentUpdate = (nextProps) => {

    //if there is no updateObject always update
    if (!nextProps.updateObject) return true;

    //if dayId is not defined in updateObject always update
    if (!nextProps.updateObject.dayId) return true;

    //if day id is defined and equal this day id, update.
    if(nextProps.updateObject.dayId === this.props.id) return true;

    //if there is a second updateObject do same logic
    if(nextProps.updateObject.secondObject)
      if(nextProps.updateObject.secondObject.dayId === this.props.id) return true;

    return false;
  };

  onSaveClick = () => {
    this.refs.calculator.submit();
    this.setState({
      hasBeenEdited: true
    })
  };

	render() {
    const { id, openCalculator, setOpenCalculator, absenceCode, isConflicting,
      normalHoursOrig, nightHoursOrig, normalHours, supplementHours, supplementRate,
      mileageNew, shackNew, conflictingProjects, conflictsWith} = this.props;


      let conflictNodes = conflictsWith.map(
            projId => <div key={projId}
                          style={styles.conflictingProjects}>
                          {conflictingProjects[projId].name}
                      </div>
          )

    return (
			<td style={[styles.td]}>

        {id === openCalculator ?
          <div>
            <buttom onClick={this.onSaveClick} className="btn btn-success waves-btn" style={styles.calculatorBtn}>Gem</buttom>
            <Calculator
              conflictNodes={conflictNodes}
              onSaveClick={this.onSaveClick}
              ref="calculator"
              {...this.props}
            />
          </div>
          :
          <div
            key="weekDayInnerContainer"
            id="weekDayInnerContainer"
            style={[styles.innerContainer,
              (isConflicting || nightHoursOrig > 0) && styles.isConflicting,
              (!isConflicting  && nightHoursOrig > 0 && styles.overSchedule),
              this.state.hasBeenEdited && styles.hasBeenEdited]}
            onClick={() => setOpenCalculator(id)}
            >
              <div className="text-center waves-btn" id="weekDayPencil" style={styles.weekDayPencil}>
                <i className="fa fa-pencil" aria-hidden="true"></i>
              </div>

              <div id="weekDayText">
                {absenceCode ? absenceCode + " - " : null}{this.props.normalHours}
              </div>

              <div id="weekDayHoverBox">
                <div style={styles.weekDayHoverBox}>
                  <div style={styles.firstRow}>
                    <div style={styles.leftContentFirstRow}>
                      <i className="fa fa-sun-o" aria-hidden="true" style={styles.marginRight}></i>
                      {normalHoursOrig}
                    </div>
                    <div style={[styles.rightContentFirstRow, nightHoursOrig > 0 && styles.overNightHours]}>
                      <i className="fa fa-moon-o" aria-hidden="true"
                        style={styles.marginRight}>
                      </i>
                      {nightHoursOrig}
                    </div>
                  </div>

                  <div style={styles.rowNormalHours}>
                    <div style={[styles.leftContentNormalHours]}>
                      Normal timer:
                    </div>
                    <div style={[styles.rightContentNormalHours]}>
                      {normalHours}
                    </div>
                  </div>

                  <div style={[styles.doubleRow]}>
                    <div style={styles.floatLeft}>
                      Tillæg:
                    </div>
                    <div style={styles.floatRight}>
                      {supplementHours*supplementRate} kr
                    </div>
                    <div style={styles.floatLeft}>
                      Timer: {supplementHours}
                    </div>
                    <div style={styles.floatRight}>
                      Sats: {supplementRate}
                    </div>
                  </div>

                  <div style={[styles.doubleRow]}>
                    <div style={styles.floatLeft}>
                      Kørsel
                    </div>
                    <div style={styles.floatRight}>
                      {mileageNew} km
                    </div>
                    <div style={styles.floatLeft}>
                      Skur
                    </div>
                    <div style={styles.floatRight}>
                      {shackNew} dage
                    </div>
                  </div>


                  <div className="text-left" style={styles.footer}>
                    <div style={styles.absenceCode}>
                      {absenceCode ? absenceCode + " (" + absenceCodes[absenceCode] + ")" : 'Ingen fravær'}
                    </div>
                  </div>

                  {isConflicting ?
                    <div style={styles.conflictprojBox}>
                      {conflictNodes}
                    </div> : null
                  }
                </div>
              </div>

          </div>
        }
      </td>
		);
	}
}

var styles = {
  td: {
    position: 'relative',
    width: '65px',
    height: '40px',
    paddingBottom: '2px',
    paddingRight: '3px'
  },
  innerContainer:{
    backgroundColor: '#fff',
    height: '100%',
    lineHeight: '40px',
    paddingRight: '5px',
    border: '1px solid #fff'
  },
  isConflicting: {
    border: '1px solid ' + semanticColors.danger
  },
  hasBeenEdited: {
    border: '1px solid ' + semanticColors.warningLight
  },
  overSchedule: {
    border: '1px solid ' + semanticColors.night
  },
  overNightHours: {
    color: semanticColors.night
  },
  weekDayHoverBox: {
    position: 'absolute',
    left: '-160px',
    top: '-55px',
    zIndex: '1',
    width: '140px',
    minHeight: '200px',
    padding: '10px',
    fontSize: '12px',
    borderRadius: '2px',
    backgroundColor: greyScaleColors.greyLighter,
    boxShadow: '0 0px 1px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
  },
  firstRow : {
    borderBottom: '1px solid ' + semanticColors.mainBackground,
    height: '30px'
  },
  leftContentFirstRow: {
    color: greyScaleColors.greyLight,
    textAlign: 'left',
    width: '60px',
    height: '26px',
    lineHeight:'26px',
    float: 'left'
  },
  rightContentFirstRow: {
    textAlign: 'right',
    width: '60px',
    height: '26px',
    lineHeight:'26px',
    float: 'right',
    color: greyScaleColors.greyLight
  },
  rowNormalHours: {
    borderBottom: '1px solid ' + semanticColors.mainBackground,
    height: '32px'
  },
  leftContentNormalHours: {
    textAlign: 'left',
    height: '32px',
    lineHeight:'32px',
    whiteSpace: 'nowrap',
    width: '60px',
    float: 'left'
  },
  rightContentNormalHours: {
    textAlign: 'right',
    height: '32px',
    width: '60px',
    lineHeight:'32px',
    float: 'right'
  },
  doubleRow:{
    borderBottom: '1px solid ' + semanticColors.mainBackground,
    height: '50px',
    lineHeight: '24px'
  },
  floatLeft: {
    float: 'left',
    textAlign: 'left',
    width: '60px'
  },
  floatRight: {
    float: 'right',
    textAlign: 'right',
    width: '60px'
  },
  footer: {
    height: '26px',
    lineHeight:'26px'
  },
  hours:{
    padding: '0px 10px'
  },
  marginRight: {
    marginRight: '10px',
    fontSize: '20px'
  },
  absenceCode: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    width: '120px',
    lineHeight: '26px'
  },
  weekDayPencil: {
    borderRadius : '0px',
    padding: '0px',
    lineHeight: 'inherit'
  },
  calculatorBtn: {
    borderRadius : '0px',
    height: '40px',
    lineHeight: '40px',
    padding: '0px 12px',
    width: '62px'
  },
  conflictingProjects: {
    height: '20px',
    lineHeight: '26px',
    fontSize: '12px',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    color: semanticColors.danger
  },
  conflictprojBox:{
    borderTop: '1px solid ' + semanticColors.mainBackground
  }
}

	WeekDay.propTypes = {
    id: PropTypes.string.isRequired,
    absenceCode: PropTypes.string,
    conflictsWith: PropTypes.array.isRequired,
    isConflicting: PropTypes.bool.isRequired,
    nightHoursOrig: PropTypes.number.isRequired,
    normalHours: PropTypes.number.isRequired,
    normalHoursOrig: PropTypes.number.isRequired,
    supplementHours: PropTypes.number.isRequired,
    supplementRate: PropTypes.number.isRequired,
    openCalculator: PropTypes.string.isRequired,
    setOpenCalculator: PropTypes.func.isRequired,
    employeeWage: PropTypes.string.isRequired,
    mileage: PropTypes.number.isRequired,
    shack: PropTypes.bool.isRequired,
    mileageNew: PropTypes.number.isRequired,
    shackNew: PropTypes.number.isRequired,
    updateDay: PropTypes.func.isRequired,
    updateObject: PropTypes.object,
    touchedByFunktionaer: PropTypes.bool.isRequired,
    latestSupplementRate: PropTypes.number.isRequired,
    conflictingProjects: PropTypes.object.isRequired
  };

export default Radium(WeekDay)


// WEBPACK FOOTER //
// ./src/App/Project/Salary/weekDay.jsx